import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

// Shown in place of the testimonials until real customer reviews are added to data/testimonials.ts
const benefits = [{
  title: 'Clear visual explanations',
  text: 'Make tooth anatomy, radiographs, procedures and materials easy to explain and easy for students to remember.'
}, {
  title: 'Six organized volumes',
  text: '300 visual training pages across every core dental teaching area, so session prep takes minutes instead of hours.'
}, {
  title: 'Professional clinical standards',
  text: 'Step-by-step procedure sequences, infection-control reminders and ❌/✅ comparisons that reinforce correct, safe technique.'
}, {
  title: 'Ready-to-use labs & assessments',
  text: 'Typodont drills, simulation exercises, quick checks and competency rubrics that keep students engaged and progressing.'
}];
export function InstructorBenefits() {
  return <section className="py-12 bg-[#F2F7F8] border-y border-slate-200" data-id="element-174" data-mp="1jjychhft2qd9">
      <div className="max-w-7xl mx-auto px-4" data-id="element-175" data-mp="1jk7yyv1n6fe7">
        <div className="text-center mb-7" data-id="element-176" data-mp="1eleprete1aju">
          <h2 className="text-[#0F4C5C] font-bold tracking-widest uppercase text-sm" data-id="element-177" data-mp="1empqf5rje26q">
            Why Dental Instructors Choose This Atlas
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178" data-mp="1ohzstulukbl1">
          {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-slate-200 p-6 rounded-2xl shadow-sm shadow-[#0F4C5C]/5 flex flex-col" data-id="element-179" data-mp="22hix2cbjf2s2" data-mpi={index}>
              <CheckCircle2 size={22} className="text-green-600 mb-3" aria-hidden="true" data-id="element-180" data-mp="2l78t12r1dulk" />
              <h3 className="font-bold text-[#0F4C5C] text-base mb-2" data-id="element-181" data-mp="2gc1vyds9vo5m">{benefit.title}</h3>
              <p className="text-slate-700 text-sm leading-relaxed" data-id="element-182" data-mp="1dydsy1vd78my">{benefit.text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}